// Module
var code = " <div class=\"view-sync-test\"> An error with the internal routing has occured. <br/><br/> <button class=\"btn btn-primary\" ng-class=\"{ disabled : vm.processing }\" ng-click=\"vm.continue\">Continue</button> </div> ";
// Exports
module.exports = code;